import React from 'react';
import {data,images} from '../../constants'
import {SubHeading,MenuItem} from '../../components'
import './SpecialMenu.css';

const SpecialMenu = () => (
  <div className='menu section__padding flex__center'>
    <div className='menu-title'>
      <SubHeading title='Menu that fits your palatte'/>
      <h1 className="headtext__cormorant">Today&apos;s Special</h1>
    </div>

    <div className='menu-menu'>
      <div className='menu_juice flex__center'>
        <p className='menu_heading'>Juices & Soft Drinks</p>
        <div className='menu_items'>
          {data.wines.map((wine,index)=>(
            <MenuItem key={wine.title + index} title={wine.title} price={wine.price} tags={wine.tags}/>
          ))}
        </div>
      </div>
      <div className='menu_img'>
        <img src={images.menu} alt="menu" />
      </div>
      <div className='menu_cocktails flex__center'>
      <p className='menu_heading'>Cocktails</p>
        <div className='menu_items'>
          {data.cocktails.map((cocktail,index)=>(
            <MenuItem key={cocktail.title + index} title={cocktail.title} price={cocktail.price} tags={cocktail.tags}/>
          ))}
      </div>
      </div>
    </div>

    <div style={{marginTop:10}}>
      <button type='button' className='custom__button'>View More</button>
    </div>
  </div>
);

export default SpecialMenu;
